"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.analyticSystemWideDataExportDownload = exports.analyticRecordsExportDownloadSite = exports.analyticRecordsExportDownloadReport = exports.analyticRecordsExportDownload = exports.analyticDataExportSuccess = exports.analyticDataExportReset = exports.analyticDataExportError = void 0;
var _analyticDataExport = require("./analyticDataExport.constant");
// common success
var analyticDataExportSuccess = function analyticDataExportSuccess(actionType, data) {
  return {
    type: _analyticDataExport.actionTypes.SUCCESS,
    payload: {
      actionType: actionType,
      data: data
    }
  };
};
// common error
exports.analyticDataExportSuccess = analyticDataExportSuccess;
var analyticDataExportError = function analyticDataExportError(actionType, error) {
  return {
    type: _analyticDataExport.actionTypes.ERROR,
    payload: {
      actionType: actionType,
      error: error
    }
  };
};

/**
 * download analytic data record
 * @param payload
 * @returns api response
 * @description this function used to download analytic data sheet.
 */
exports.analyticDataExportError = analyticDataExportError;
var analyticRecordsExportDownload = function analyticRecordsExportDownload(data) {
  return {
    type: _analyticDataExport.actionTypes.RECORDS_EXPORT_DOWNLOAD,
    payload: data
  };
};

/**
 * download analytic data record
 * @param payload
 * @returns api response
 * @description this function used to download analytic data sheet.
 */
exports.analyticRecordsExportDownload = analyticRecordsExportDownload;
var analyticRecordsExportDownloadSite = function analyticRecordsExportDownloadSite(data) {
  return {
    type: _analyticDataExport.actionTypes.RECORDS_EXPORT_DOWNLOAD_SITE,
    payload: data
  };
};

/**
 * download analytic data record
 * @param payload
 * @returns api response
 * @description this function used to download analytic data sheet.
 */
exports.analyticRecordsExportDownloadSite = analyticRecordsExportDownloadSite;
var analyticRecordsExportDownloadReport = function analyticRecordsExportDownloadReport(data) {
  return {
    type: _analyticDataExport.actionTypes.RECORDS_EXPORT_DOWNLOAD_REPORT,
    payload: data
  };
};

/**
 * download system wide data
 * @param payload
 * @returns api response
 * @description this function used to download system wide data.
 */
exports.analyticRecordsExportDownloadReport = analyticRecordsExportDownloadReport;
var analyticSystemWideDataExportDownload = function analyticSystemWideDataExportDownload(data) {
  return {
    type: _analyticDataExport.actionTypes.SYSTEM_WIDE_DATA_EXPORT_DOWNLOAD,
    payload: data
  };
};

/**
 * reset
 * @param payload
 * @returns api response
 * @description this function used to reset.
 */
exports.analyticSystemWideDataExportDownload = analyticSystemWideDataExportDownload;
var analyticDataExportReset = function analyticDataExportReset() {
  return {
    type: _analyticDataExport.actionTypes.RESET
  };
};
exports.analyticDataExportReset = analyticDataExportReset;